import { API } from "aws-amplify";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Card, Col, Row, Table } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import swal from "sweetalert";
import StorageType from '../../data/storage-type.json';
import { FormError, isViewer } from "../../helpers";
import PackageCount from './../../data/packageCount.json';

const NONPhoxTailPackageSection = ({ packages, packageCount, packageErrors, handleItems, myShipper, myShippers, handlePackages, scanPackageData, shipmentUpdate, updateShipmentFunc, setPackageErrors, greenPhox, shipperSettings, isColdChain }) => {

    const onDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination) return;
        const sourcePackageIndex = parseInt(source.droppableId, 10);
        const destinationPackageIndex = parseInt(destination.droppableId, 10);
        const sourceItemIndex = source.index;
        const destinationItemIndex = destination.index;

        let updatedPackages = packages.map(pkg => ({
            ...pkg,
            items: [...pkg.items]
        }));

        const draggedItem = updatedPackages[sourcePackageIndex].items[sourceItemIndex];
        updatedPackages[sourcePackageIndex]?.items?.splice(sourceItemIndex, 1);
        updatedPackages[destinationPackageIndex]?.items?.splice(destinationItemIndex, 0, draggedItem);

        updatedPackages = updatedPackages?.filter((pkg) => pkg?.items?.length > 0)
        const updatedPackageCount = updatedPackages.length;
        handlePackages(updatedPackages, updatedPackageCount);
        if (shipmentUpdate) {
            updateShipmentFunc(updatedPackages);
        }
        if (packageErrors?.length > 0 && scanPackageData) {
            let errorList = [];
            const numberMap = new Map()
            updatedPackages?.forEach((pkg, pkgIndex) => {
                pkg?.items?.forEach((item, itemIndex) => {
                    let errors = {};
                    if (item?.name === "Drug") {
                        if (!item.number || item.number.trim() === '') {
                            errors.number = 'required';
                        }
                        if (!item.description || item.description.trim() === '') {
                            errors.description = 'required';
                        }
                        if (!item.ndc || item.ndc.trim() === '') {
                            errors.ndc = 'required';
                        }
                        if (!item.quantity || item.quantity.trim() === '') {
                            errors.quantity = 'required';
                        }
                    }
                    const refNumber = item?.number;
                    if (refNumber && numberMap.has(refNumber)) {
                        errors.duplicateReferenceNumber = 'Duplicate reference number.';
                    } else if (refNumber) {
                        numberMap.set(refNumber, { pkgIndex, itemIndex });
                    }

                    if (Object.keys(errors).length > 0) {
                        errorList.push({ pkgIndex, itemIndex, errors });
                    }
                });
            });
            setPackageErrors(errorList);
        };
    }

    const addShipmentItem = (key) => {
        const newItems = [...(packages || [])];
        newItems[key] = newItems[key] || [];
        newItems[key].items.push({ id: 'NEW', name: 'Drug', number: '' });
        handleItems(newItems)
    };

    const removeShipmentItem = (index, key) => {
        const newItems = [...(packages || [])];
        newItems[key] = newItems[key] || [];
        newItems[key].items.splice(index, 1);

        handleItems(newItems)
    };

    const handleItemProductChange = (index, id, name, key) => {
        const newItems = [...(packages || [])];
        newItems[key] = newItems[key] || [];
        newItems[key].items[index] = newItems[key].items[index] || {};
        newItems[key].items[index].id = id;
        newItems[key].items[index].name = name;
        handleItems(newItems)
    };

    const handleItemNumberChange = (index, value, key) => {
        const newItems = [...(packages || [])];
        newItems[key] = newItems[key] || [];
        newItems[key].items[index] = newItems[key].items[index] || {};
        newItems[key].items[index].number = value;
        handleItems(newItems)
    };

    const removePackage = async (key, newItems) => {
        swal({
            text: `You will lose the Package data if you continue. Are you sure you want to continue?`,
            buttons: ['No', 'Yes'],
            icon: 'error',
            dangerMode: true,
        }).then(async (status) => {
            if (status) {
                while (newItems.length > key) {
                    newItems.pop();
                }
                handlePackages(newItems, PackageCount[key]);
            }
        });
    };

    const handlePackageCount = (key) => {
        const currentItems = packages.map(pkg => ({
            ...pkg,
            items: [...pkg.items]
        })) || [];
        const currentItemsCount = currentItems.length;
        let newItems = [...currentItems];
        let storageType = "ROOM_TEMPERATURE";
        if (greenPhox) {
            storageType = 'COLD_CHAIN'
        }
        const coldChain = shipperSettings?.findIndex(x => x.key === 'shipment_cold_chain_required') || isColdChain
        if (coldChain >= 0 && shipperSettings[coldChain].value === 'Yes') {
            storageType = 'COLD_CHAIN'
        }

        if (currentItemsCount > key) {
            const hasValueInRemovedArray = currentItems[key]?.items?.some((item) => item.number !== '');
            if (hasValueInRemovedArray) {
                removePackage(key, newItems);
                return;
            } else {
                while (newItems.length > key) {
                    newItems.pop();
                }
                handlePackages(newItems, PackageCount[key]);
            }

            let errorList = [];
            const numberMap = new Map();
            newItems.forEach((pkg, pkgIndex) => {
                pkg?.items?.forEach((item, itemIndex) => {
                    let errors = {};
                    const refNumber = item.number;
                    if (refNumber && numberMap.has(refNumber)) {
                        errors.duplicateReferenceNumber = 'Duplicate reference number.';
                    } else if (refNumber) {
                        numberMap.set(refNumber, { pkgIndex, itemIndex });
                    }
                    if (Object.keys(errors).length > 0) {
                        errorList.push({ pkgIndex, itemIndex, errors });
                    }
                });
            });
            setPackageErrors(errorList);

        }
        let packageItem = scanPackageData ? [{ id: 'NEW', name: "Drug", number: "", tier: 0, description: "", unit: "EA", ndc: "", quantity: "", isNew: shipmentUpdate ? true : false }] : [{ id: 'NEW', name: "Drug", number: "", isNew: shipmentUpdate ? true : false }]
        let count = packages?.length
        while (newItems.length < key) {
            count = count + 1
            newItems.push(
                {
                    name: `Package${count}`,
                    package_type: storageType,
                    items: packageItem
                },
            );
        }
        handlePackages(newItems, PackageCount[key]);
    };

    const searchProducts = async (keyword) => {
        try {
            const apiName = 'api';
            const path = `/search/product?size=1000&from=0`;
            const init = {
                body: {
                    "sort": [
                        {
                            "name.keyword": {
                                "order": "asc"
                            }
                        }
                    ],
                    "query": {
                        "bool": {
                            "must": [
                                {
                                    "match": {
                                        "shipperId": myShipper?.shipper.id || myShippers[0]?.shipper?.id
                                    }
                                }
                            ]
                        }
                    }
                },
            };
            if (keyword) {
                let fields = ["name"]
                init.body.query.bool.must.push(
                    {
                        "multi_match": {
                            "query": keyword,
                            "fields": fields
                        }
                    }
                )
            }
            const { hits } = await API.post(apiName, path, init);
            const sourceData = hits?.hits?.length > 0 ? hits?.hits?.map((item) => item?._source) : [];
            sourceData?.unshift({ id: 'NEW', name: "Drug" });
            return sourceData.map((item) => ({
                value: item.id,
                label: item.name,
            }));
        } catch (error) {
            console.error('ealstic error', error);
        }
    };

    const removePackages = (index) => {
        const hasValueInRemovedArray = packages[index]?.items?.some((item) => item.number !== '');
        const confirmAndRemovePackage = () => {
            let newItems = [...packages];
            newItems.splice(index, 1);
            const updatedErrors = packageErrors.filter((error) => error.pkgIndex !== index);
            const shiftedErrors = updatedErrors.map((error) =>
                error.pkgIndex > index ? { ...error, pkgIndex: error.pkgIndex - 1 } : error
            );

            setPackageErrors(shiftedErrors);
            if (shipmentUpdate) {
                updateShipmentFunc(newItems, newItems.length)
            } else {
                handlePackages(newItems, newItems.length);
            }
        };
        if (hasValueInRemovedArray || shipmentUpdate) {
            swal({
                text: `You will lose the Package data if you continue. Are you sure you want to continue?`,
                buttons: ['No', 'Yes'],
                icon: 'error',
                dangerMode: true,
            }).then(async (status) => {
                if (status) {
                    confirmAndRemovePackage();
                }
            });
        } else {
            confirmAndRemovePackage();
        }
    };

    const getErrorMessage = (pkgIndex, itemIndex, field) => {
        const error = packageErrors?.find((err) => err.pkgIndex === pkgIndex && err.itemIndex === itemIndex);
        return error?.errors[field] || '';
    };

    const handleStorageType = (key, storagekey) => {
        const newPackage = [...(packages || [])];
        if (!newPackage[key]) newPackage[key] = [];
        newPackage[key].package_type = storagekey;
        if (shipmentUpdate) {
            updateShipmentFunc(newPackage)
        } else {
            handleItems(newPackage);
        }
    };

    let showButtonsFlag = !isViewer((myShipper?.role || myShippers[0]?.role)) ? true : false;

    return (
        <>
            <section className='mt-4'>
                <h4>Package Count </h4>
                {
                    Object.keys(PackageCount).map((key, index) => {
                        return (
                            <button key={index}
                                className={`btn btn-md btn-${packageCount === PackageCount[key] ? 'success' : 'light'} me-2 mt-2`}
                                onClick={() => handlePackageCount(key)}
                            >{PackageCount[key]}</button>
                        )
                    })
                }
            </section>
            <div className='mt-4'>
                <Row className="mb-2 d-flex  align-items-center" >
                    <Col className="auto">
                        <h4 className='mt-2'>Package Contents {`(${packages?.length} / 5)`}</h4>
                    </Col>
                </Row>
                <DragDropContext onDragEnd={onDragEnd}>
                    {packages?.length > 0 &&
                        packages.map((pkg, key) => (
                            <Droppable droppableId={`${key}`} key={key}>
                                {(provided) => (
                                    <div key={key} ref={provided.innerRef} {...provided.droppableProps}>
                                        <Card>
                                            <Card.Header>
                                                <Row>
                                                    <Col className="d-flex gap-2 align-items-center">
                                                        <h4 className="card-header-title  me-0 ">Package {key + 1}</h4>
                                                        {
                                                            Object.keys(StorageType).map((storagekey, index) => {
                                                                const packageStorage = packages[key]?.package_type;
                                                                return (
                                                                    <>
                                                                        {
                                                                            <button key={index}
                                                                                disabled={greenPhox || !showButtonsFlag}
                                                                                className={`btn btn-sm btn-${StorageType[packageStorage] === StorageType[storagekey] ? "success" : 'light'} py-2 px-3 mx-1`}
                                                                                onClick={() => handleStorageType(key, storagekey)}>
                                                                                {packages[key].package_type === StorageType[storagekey] && <i className="fe fe-check-circle me-2"></i>}    {StorageType[storagekey]}
                                                                            </button >
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </Col>
                                                    {showButtonsFlag && (
                                                        <Col className="col-auto mx-1 mt-1">
                                                            {packages.length > 1 && (
                                                                <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => removePackages(key)}>
                                                                    <i className="fe fe-trash"></i>
                                                                </button>
                                                            )}
                                                        </Col>
                                                    )}
                                                </Row>
                                            </Card.Header>
                                            <Table size='sm' className='mb-0'>
                                                <thead>
                                                    <tr>
                                                        {showButtonsFlag && <th className="m-0 p-0 text-center"></th>}
                                                        <th className='text-center'>#</th>
                                                        <th>Product</th>
                                                        <th>Reference Number</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {pkg?.items?.length > 0 &&
                                                        pkg?.items?.map((item, index) => (
                                                            <Draggable
                                                                isDragDisabled={!showButtonsFlag}
                                                                key={`${key}-${index}`}
                                                                draggableId={`${key}-${index}`}
                                                                index={index}
                                                            >
                                                                {(provided) => (
                                                                    <tr
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        key={`${key}-${index}`}
                                                                    >
                                                                        <td
                                                                            className="m-0 p-0 text-center border-end"
                                                                            {...provided.dragHandleProps}
                                                                        >
                                                                            <img src="/img/drag.svg" alt="drag-svg" height={'20'} />
                                                                        </td>
                                                                        <td className='text-center'>{`${index + 1}`}</td>
                                                                        <td>
                                                                            <AsyncSelect
                                                                                value={{
                                                                                    label: item?.name || 'Drug',
                                                                                    value: item?.id || 'NEW',
                                                                                }}
                                                                                placeholder='Drug'
                                                                                defaultOptions
                                                                                loadOptions={searchProducts}
                                                                                onChange={(e) =>
                                                                                    handleItemProductChange(index, e.value, e.label, key)
                                                                                }
                                                                            />
                                                                            <FormError error={getErrorMessage(key, index, 'description')} />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                className='form-control'
                                                                                key={index}
                                                                                type='text'
                                                                                name={`orderNumber-${index}`}
                                                                                placeholder='e.g. 1112-12322'
                                                                                value={item?.number}
                                                                                onChange={(e) =>
                                                                                    handleItemNumberChange(index, e.target.value, key)
                                                                                }
                                                                            />
                                                                            <FormError error={getErrorMessage(key, index, 'number')} />
                                                                            <FormError error={getErrorMessage(key, index, 'duplicateReferenceNumber')} />
                                                                        </td>
                                                                        <td className='text-center'>
                                                                            {index === 0 && <button className='btn btn-sm btn-light me-2' onClick={() => addShipmentItem(key)}  >
                                                                                <i className="fe fe-plus"></i>  {!scanPackageData && 'Add Item'}
                                                                            </button>}
                                                                            {pkg.items.length > 1 && (
                                                                                <button
                                                                                    className='btn btn-sm btn-outline-secondary'
                                                                                    onClick={() => removeShipmentItem(index, key)}
                                                                                >
                                                                                    <i className='fe fe-trash'></i>
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                    {provided.placeholder}
                                                </tbody>
                                            </Table>
                                        </Card>
                                    </div>
                                )}
                            </Droppable>
                        ))
                    }
                </DragDropContext>
            </div >

        </>
    )
};

export default NONPhoxTailPackageSection;